// extracted by mini-css-extract-plugin
module.exports = {"container":"InfaWBL05PXZWwfxtdyXQ"};